import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zichanluru",
  "use": "icon-zichanluru-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zichanluru\"><path d=\"M940.8 70.4c-46.4-46.4-113.6-56.8-148-21.6l-42.4 42.4L920 262.4l42.4-42.4c35.2-36 26.4-103.2-21.6-149.6zM714.4 125.6L335.2 504.8c-12.8 12.8-20 26.4-20 26.4s-79.2 182.4-84 198.4c-3.2 16-0.8 30.4 5.6 37.6 6.4 6.4 24.8 6.4 41.6 3.2 10.4-2.4 65.6-20 121.6-43.2 49.6-21.6 100.8-46.4 107.2-52.8 12.8-12.8 378.4-376.8 378.4-376.8L714.4 125.6zM507.2 603.2l-29.6 29.6c-13.6 13.6-24.8 21.6-66.4 39.2-42.4 18.4-92.8 39.2-97.6 41.6-10.4 3.2-19.2 6.4-24.8 0.8-5.6-5.6 8-28 10.4-40.8 4.8-16 68-130.4 68-130.4l29.6-29.6 317.6-317.6 99.2 99.2-306.4 308z\" /><path d=\"M903.2 958.4V457.6l-84.8 84.8v368.8H140.8v-784h409.6L635.2 42.4H93.6C72 42.4 56 59.2 56 80v878.4c0 21.6 16.8 37.6 37.6 37.6h772.8c20 0 36.8-16.8 36.8-37.6zM140.8 127.2z m677.6 784z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zichanluru.svg
// module id = gRra
// module chunks = 143